/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function EditIconPurpleSmall(props: IconProps) {
	const { color = 'primary' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-1149 -242)">
					<g transform="translate(1149 242)">
						<path d="M9.13168421 1.08131579L12.6444561 4.60170175 11.942 5.30587719 8.42922807 1.78549123z" />
						<path d="M2.10638596 8.12257895L5.61915789 11.6429649 4.91670175 12.3471404 1.40392982 8.82650877z" />
						<path d="M12.293 1.434c.581.582.581 1.53 0 2.112L8.78 7.066l-.702.704-4.353 4.363-2.634.53.527-2.643L5.97 5.658l4.216-4.225a1.49 1.49 0 012.107 0m.703-.704a2.48 2.48 0 00-3.513 0L5.268 4.954.702 9.53 0 13.05l.701.706 3.514-.706L8.78 8.475l.703-.704 3.513-3.521c.97-.973.97-2.549 0-3.52z" />
					</g>
				</StyledG>
			</g>
		</svg>
	);
}

export default EditIconPurpleSmall;
